module.exports = __webpack_public_path__ + "img/beex-full-logo.a6b92b88.png";